import React, { useEffect, useState } from "react";
import _ from 'lodash';
import moment from 'moment';
import { Doughnut } from 'react-chartjs-2';
import { Button, Typography, Card, Col, Row, Divider, Table, Layout, DatePicker, Radio, Space, PageHeader, Avatar} from "antd";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import OverviewCard from "../../components/Card/OverviewKpiCard";
import LineGraph from "./Kpi_Dashboard/lineGraph";
import DashboardService from "../../services/DashboardService";

const { Content } = Layout;

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

const Dashboard = () => {
  const [fromDate, setFromDate] = useState(moment().startOf('week').format('DD-MM-YYYY'));
  const [toDate, setToDate] = useState(moment().endOf('week').format('DD-MM-YYYY'));
  const [size, setSize] = useState('week');
  const [data, setData] = useState({});
  const [showPopular, setShowPopular] = useState(true);


  const getData = () => {
    DashboardService.getCateringDashboard(moment(fromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(toDate, 'DD-MM-YYYY').format('YYYY-MM-DD')).then((res)=>{
      setData(res);
    });
  }

  useEffect(()=>{
    getData();
  },[toDate, fromDate]);
  const data1 = {
    labels: data?.sales_by_menu_section?.map((itm)=>itm.menu_section),
    datasets: [
      {
        data: data?.sales_by_menu_section?.map((itm)=>itm.sales),
        backgroundColor: ["#FF94C1", "#DB0404", "#FF5E71"],
        borderColor: ["#FF94C1", "#DB0404", "#FF5E71"],
        borderWidth: 1,
      },
    ],
  };
  const Course_data = {
    labels: data?.sales_by_category?.map((itm)=>itm.category),
    datasets: [
      {
        data: data?.sales_by_category?.map((itm)=>itm.sales),
        backgroundColor: ["#FF94C1", "#DB0404", "#FF5E71"],
        borderColor: ["#FF94C1", "#DB0404", "#FF5E71"],
        borderWidth: 1,
      },
    ],
  };
  const column2 = [{
    title: "NAME OF ITEM",
    dataIndex: "name",
    key: "name",
    render: (_, record) => {
      return (
        <div className="flex">
          <Avatar shape="square" size={50} src={record?.item_photo}
                    style={{ marginRight: "20px" }} />
          <div className="item-name">{record?.item_name}</div>
        </div>
      );
    },
  },
  {
    title: "UNITS SOLD",
    dataIndex: "units_sold",
    key: "units_sold"
  },
  {
      title: "%AGE OF SALE",
      dataIndex: "percentange_of_sale",
      key: "percentange_of_sale",
      render: (_, record) => {
        return (
          <div style={{ display: "flex", justifyContent:"center" }} >
            <div  className="name_text red">
              {record?.percentange_of_sale?.toFixed(2)}%
            </div>
          </div>
        );
      },
    }
  ];

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        align: "center",
        labels: {
          boxWidth: 20,
          useBorderRadius: true,
          borderRadius: 120,
          usePointStyle: true,
        },
      },
    },
  };
  const onFilterDateChange = (date, dateString, field) => {
    if(field === 'starDate'){
      setFromDate(moment(dateString, 'MMM DD, YYYY'));
    } else {
      setToDate(moment(dateString, 'MMM DD, YYYY'));
    }
    setSize('');
  };
  const onPeriodChange = (e) => {
    setSize(e.target.value);
    setFromDate(moment().startOf(e.target.value).format('DD-MM-YYYY'));
    setToDate(moment().endOf(e.target.value).format('DD-MM-YYYY'))
  }
  const onReset = () => {
    setSize('week');
    setFromDate(moment().startOf('week').format('DD-MM-YYYY'));
    setToDate(moment().endOf('week').format('DD-MM-YYYY'))
  }
  return (
    <Layout className="u-page-layout">
    <Content className="w-full kpi_dboard page-padding">
      <Space className="w-full" direction="vertical">
        <PageHeader
          title="Catering Status"
          className="page-header"
          extra={[
            <>
            <Row>
              <Col>
              <div className="flex" style={{ border: size ? "0px" : "2px solid red"}}>
                <div className=""><DatePicker name="starDate" allowClear={false} onChange={(date, dString)=>onFilterDateChange(date, dString, "starDate")} value={moment(fromDate, "DD-MM-YYYY")} format="MMM DD, YYYY" /></div>
                <div className=""><DatePicker name="endDate" allowClear={false} onChange={(date, dString)=>onFilterDateChange(date, dString, 'endDate')} value={moment(toDate, "DD-MM-YYYY")} format="MMM DD, YYYY" /></div>
                <Button type={size ? "dashed" : "primary" } onClick={onReset}>Reset</Button>
              </div>
              </Col>
              <Col>
              <div>
               <Radio.Group value={size} onChange={onPeriodChange}>
                <Radio.Button value="week">This Week</Radio.Button>
                <Radio.Button value="month">This Month</Radio.Button>
                <Radio.Button value="year">This Year</Radio.Button>
              </Radio.Group>
            </div>
            </Col>
            </Row>
            </>
          ]}
        />
      </Space>
        <div className="text-left flex flex_wrap p-1">
          <div>
            <OverviewCard title={data?.total_orders || 0} subTitle="Total catering orders today" subview="" className="min_kpi_card_size"/>
          </div>
          <div>
            <OverviewCard title={data?.unaccepted_orders || 0}  subTitle="Unaccepted Catering orders" subview="" className="min_kpi_card_size"/>
          </div>
          <div>
            <OverviewCard title={data?.total_orders_week || 0} subTitle="Catering orders this week" subview="" className="min_kpi_card_size"/>
          </div>
        </div>
        <Divider plain></Divider>

        <Space className="w-full" direction="vertical">
          <PageHeader className="page-header" title="Sales by Catering" extra={[]}/>
        </Space>
        <div className="text-left flex flex_wrap p-1">
          <div>
            <OverviewCard title={"$ " + _.round(data?.sales_today || 0) } subTitle="Sales Today" className="min_kpi_card_size" />
          </div>
          <div>
            <OverviewCard title={"$ " + _.round(data?.sales_week || 0) } subTitle="Sales this Week" className="min_kpi_card_size"/>
          </div>
          <div>
            <OverviewCard title={"$ " + _.round(data?.sales_month || 0) } subTitle="Sales this Month" className="min_kpi_card_size"/>
          </div>
          <div>
            <OverviewCard title={"$ " + _.round(data?.sales_ytd || 0)} subTitle="Sales YTD" className="min_kpi_card_size"/>
          </div>
        </div>
        <Divider plain />

          <Row className="text-left tips-card-margin" gutter={[16, 16]}>
                          <Col xs={24} md={11} lg={11}>
                <Card
                  title={<div className="card_heading">Course wise sales</div>}
                  bordered={false}
                  style={{ width: "100%", height:550}}
                >
                  <div className="graph_container">
                    <Doughnut data={Course_data} options={options} />
                  </div>
                </Card>
              </Col>
              <Col xs={24} md={11} lg={11}>
                <Card
                  title={<div className="card_heading">Sales by Menu Section</div>}
                  bordered={false}
                  style={{ width: "100%", height:550}}
                >
                  <div className="graph_container">
                    <Doughnut data={data1} options={options} />
                  </div>
                </Card>
              </Col>
          </Row>
          <Row className="text-left tips-card-margin" gutter={[16, 16]}>
          <Col xs={24} md={11} lg={11}>
                <Card
                  bordered={false}
                  className="full_space"
                  title={<div className="card_heading">Sales Overview</div>}
                >
                  <LineGraph revenue_overview={data?.sales_overview || []}/>
                </Card>
              </Col>
              <Col xs={24} md={11} lg={11}>

                <Card
                  title={showPopular? <div>
                    <span className="red">Popular Items </span>
                    <span onClick={()=>{setShowPopular(false)}} className="cursor-pointer">| Least Popular Items</span>
                    </div> :
                  <div>
                    <span onClick={()=>{setShowPopular(true)}} className="cursor-pointer">Popular Items | </span>
                    <span className="red">Least Popular Items</span>
                  </div>}
                  bordered={false}
                  className="full_space"
                >
                  <div>
                  <Table
                    columns={column2}
                    dataSource={data && data[showPopular ? 'popular_items' : 'unpopular_items']||[]}
                    className="popular_list-table"
                    pagination={false}
                  />
                  </div>
                </Card>
              </Col>
            </Row>
      </Content>
    </Layout>
  );
};
export default Dashboard;
